import { render } from "./PostList.vue?vue&type=template&id=153b939f&scoped=true"
import script from "./PostList.vue?vue&type=script&lang=js"
export * from "./PostList.vue?vue&type=script&lang=js"

import "./PostList.vue?vue&type=style&index=0&id=153b939f&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Admin\\Desktop\\Ulbi\\BlogApp\\blog_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-153b939f"]])

export default __exports__